
async function onAddToCart(variantId, quantity = 1, { openDrawer = true } = {}) {


  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'js_addtc';
  btn.setAttribute('data-id', String(variantId));
  btn.setAttribute('data-metadata', JSON.stringify({
    action: { addToCart: { productId: String(variantId) } }
  }));

  btn.style.cssText = 'position:absolute;left:-99999px;top:-99999px;opacity:0;pointer-events:none;';
  document.body.appendChild(btn);

  try {
    await clickBoostButton(btn, quantity);
  } finally {
    btn.remove();
  }


  if (!openDrawer) {
    const canvas = document.getElementById('nt_cart_canvas');
    canvas?.classList.add('dn');
    canvas?.classList.remove('act_opened');
  }
}

function clickBoostButton(buttonEl, quantity) {
  return new Promise(resolve => {
    let clicks = 0;

    const done = () => {
      document.removeEventListener('cart:updated', onUpdated, true);
      document.removeEventListener('cart:change', onUpdated, true);
      document.removeEventListener('theme:cart:change', onUpdated, true);
      resolve();
    };
    const onUpdated = () => done();

    document.addEventListener('cart:updated', onUpdated, true);
    document.addEventListener('cart:change', onUpdated, true);
    document.addEventListener('theme:cart:change', onUpdated, true);

    const safety = setTimeout(done, 3000);

    const doClick = () => {
      buttonEl.click();
      clicks += 1;
      if (clicks < quantity) {
            setTimeout(doClick, 150);
      } else {
             }
    };

    doClick();
  });
}


